import { isElectronDesktop } from '@/lib/electron-bridge';

/** The installed web app's service worker, from `public/sw.js`. */
const SERVICE_WORKER_URL = '/sw.js';

/** Registers the service worker that makes a browser's Crowdex installable (not in Desktop). */
export function registerServiceWorker(): void {
  if (isElectronDesktop() || !('serviceWorker' in navigator)) return;
  navigator.serviceWorker.register(SERVICE_WORKER_URL, { scope: '/' }).catch((error: unknown) => {
    console.warn('The service worker was not registered.', error);
  });
}
